export default () => {
    let forwardDeleteModal = document.getElementById('forwardDeleteModal');
    if (!forwardDeleteModal) {
        return;
    }
    forwardDeleteModal.addEventListener('show.bs.modal', function (event) {
        let button = $(event.relatedTarget);
        let forward = button.data('forward');
        let email = button.data('email');
        let action = button.data('action');

        let modal = $(this);
        modal.find('#forwardDelete').attr('action', action);
        modal.find('#email').val(email);
        modal.find('.forward').val(forward);
    });
};
